import React from 'react';

const formatDeviceInfo = (info) => {
  if (!info?.device) return 'No Info Available';
  if (info.device.manufacturer || info.device.model) {
    return [info.device.manufacturer, info.device.model].filter(Boolean).join(' ');
  }
  return 'No Info Available';
};

const NO_INFO = 'No Info Available';

const getRawValue = (info, field) => {
  const profile = info?.profile || {};
  const imaging = info?.imaging || {};
  const wb = imaging?.whiteBalance || {};
  const getters = {
    resolution: () => profile.resolution,
    encodingType: () => profile.encodingType,
    bitrate: () => profile.bitrate,
    fps: () => profile.fps,
    gop: () => profile.gop,
    sharpness: () => imaging.sharpness,
    saturation: () => imaging.saturation,
    brightness: () => imaging.brightness,
    contrast: () => imaging.contrast,
    autoFocusMode: () => imaging.autoFocusMode,
    whiteBalanceMode: () => wb.mode,
    whiteBalanceCrGain: () => wb.crGain,
    whiteBalanceCbGain: () => wb.cbGain,
  };
  const fn = getters[field];
  return fn ? fn() : undefined;
};

const formatSingleField = (info, field) => {
  if (!info) return NO_INFO;
  const value = getRawValue(info, field);
  if (value == null) return NO_INFO;
  return field === 'bitrate' ? `${value} kbps` : String(value);
};

export const getCameraInfoDisplayValue = (cameraSettings, section) => {
  const cameraInfo = cameraSettings || null;
  if (section === 'device') {
    return formatDeviceInfo(cameraInfo);
  }
  const singleFieldSections = [
    'resolution', 'encodingType', 'bitrate', 'fps', 'gop',
    'sharpness', 'saturation', 'brightness', 'contrast',
    'autoFocusMode', 'whiteBalanceMode', 'whiteBalanceCrGain', 'whiteBalanceCbGain',
  ];
  if (singleFieldSections.includes(section)) {
    return formatSingleField(cameraInfo, section);
  }
  return 'No data available';
};

const CameraInfo = ({ cameraSettings, section }) => {
  const content = getCameraInfoDisplayValue(cameraSettings, section);

  return (
    <div className="form-group">
      <div className="form-row justify-content-center">
        <pre className="m-0 d-flex flex-column justify-content-around text-center">
          {content || 'No Info Available'}
        </pre>
      </div>
    </div>
  );
};

export default CameraInfo;

